export default __webpack_public_path__ + "static/media/community.cea4a6b1.png";